/* eslint-disable */
// @ts-nocheck

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import query from '@/api/APIServicesV2'
import { getErrorMessage } from '@/utils/errorHandlers'

export const GET_ALL_CONTAINERS_QUERY_KEY = 'containers'
export const GET_CONTAINER_QUERY_KEY = (containerId: number) => [
  'container',
  containerId,
]
interface DispatchContainerPayload {
  areaId: number
  observations?: string
}
interface DispatchContainerParams {
  containerId: string
  areaId: number
  observations?: string
}

export function useServerLogisticContainer() {
  const queryClient = useQueryClient()

  const getContainers = () => {
    return useQuery({
      queryKey: ['containers'],
      queryFn: async () => {
        const response = await query.get('/containers')
        return response.data
      },
      staleTime: 30 * 60 * 1000,
      gcTime: 45 * 60 * 1000,
    })
  }
  const getContainer = (containerId: number) => {
    return useQuery({
      queryKey: ['container', containerId],
      queryFn: async () => {
        const response = await query.get(`/containers/${containerId}`)
        return response.data
      },
      enabled: !!containerId,
      staleTime: 30 * 60 * 1000,
      gcTime: 45 * 60 * 1000,
    })
  }

  const createContainer = (data: any) => {
    return useMutation({
      mutationFn: async () => {
        const response = await query.post('/containers', data)
        return response.data
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_ALL_CONTAINERS_QUERY_KEY],
        })
      },
    })
  }

  const updateContainer = (containerId: number, data: any) => {
    return useMutation({
      mutationFn: async () => {
        const response = await query.put(`/containers/${containerId}`, data)
        return response.data
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [
            GET_CONTAINER_QUERY_KEY(containerId),
            GET_ALL_CONTAINERS_QUERY_KEY,
          ],
        })
      },
    })
  }
  const deleteContainer = (containerId: number) => {
    return useMutation({
      mutationFn: async () => {
        const response = await query.deleteAPI(`/containers/${containerId}`)
        return response.data
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_ALL_CONTAINERS_QUERY_KEY],
        })
      },
    })
  }

  const dispatchContainer = () => {
    return useMutation({
      mutationFn: async (data: DispatchContainerParams) => {
        const payload: DispatchContainerPayload = {
          areaId: data.areaId,
          observations: data.observations || '',
        }
        const response = await query.post(
          `/dispatch/${data.containerId}`,
          payload
        )
        return response.data
      },
      onMutate: () => {
        toast.dismiss()
        toast.info('Desagrupando contenedor...', {
          toastId: 'dispatch-container',
          autoClose: false,
        })
      },
      onSuccess: () => {
        toast.dismiss('dispatch-container')
        toast.success('Contenedor desagrupado correctamente')
        queryClient.invalidateQueries({
          queryKey: [GET_ALL_CONTAINERS_QUERY_KEY],
        })
        // Invalidate cache dispatch
        queryClient.invalidateQueries({
          queryKey: ['dispatches'],
        })
        // Invalidate inventory cache
        queryClient.invalidateQueries({
          queryKey: ['containers-products'],
        })
        queryClient.invalidateQueries({
          queryKey: ['product-details'],
        })
      },
      onError: (error: any) => {
        toast.dismiss('dispatch-container')
        const errorMessage = getErrorMessage(error)
        toast.error(errorMessage)
      },
      onSettled: () => {
        toast.dismiss('dispatch-container')
      },
    })
  }

  return {
    getContainers,
    getContainer,
    createContainer,
    updateContainer,
    deleteContainer,
    dispatchContainer,
  }
}
